export default "__VITE_PUBLIC_ASSET__30cf2380__"